<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <path fill="#65A2D9" d="M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z"/>
    <path fill="#fff" d="M12.21 8.698c-.146-.2-.213-.446-.213-.694V8c0-2.208-1.79-3.997-3.997-3.997-.483 0-.946.086-1.374.243-.232.085-.486.1-.724.034-.21-.06-.434-.084-.666-.068-.976.067-1.762.867-1.812 1.844-.025.466.115.899.366 1.246.146.2.213.446.213.694V8c0 2.208 1.79 3.997 3.997 3.997.483 0 .946-.085 1.374-.243.232-.085.486-.1.724-.034.21.06.434.084.666.068.976-.067 1.762-.867 1.813-1.844.024-.466-.116-.899-.367-1.246zM8.146 7.283c.806.192 2.024.482 2.024 1.823 0 .661-.325 1.165-.916 1.42-.422.181-.9.206-1.31.206-1.265 0-2.063-.983-2.096-1.025-.207-.26-.165-.638.095-.845.26-.207.638-.164.845.096.002.002.48.55 1.155.572.815.025 1-.217 1.025-.424.03-.252-.195-.438-1.1-.653-.767-.182-1.925-.458-1.925-1.693 0-.385.156-1.64 2.17-1.64 1.272 0 2.022 1 2.053 1.043.197.268.14.644-.128.84-.266.197-.64.14-.838-.124-.014-.018-.443-.496-1.087-.557-.487-.046-.968.13-.968.389 0 .275.138.367 1.001.572z"/>
    <path fill="#fff" d="M8.968 9.107c.027-.231-.158-.406-.878-.598v1.023c.69-.007.855-.232.878-.425zM7.145 6.71c0 .27.133.364.945.56v-.95c-.48-.038-.945.135-.945.39z"/>
  </svg>
</template>

<script>
  export default {
    name: "Skype"
  }
</script>

<style scoped>

</style>